import { useRef, useCallback } from 'react';

export function useSwipeBack(onBack) {
  const touchStartRef = useRef(null);

  const handleTouchStart = useCallback((e) => {
    const touch = e.touches[0];
    if (touch.clientX <= 25) {
      touchStartRef.current = { x: touch.clientX, y: touch.clientY };
    } else {
      touchStartRef.current = null;
    }
  }, []);

  const handleTouchEnd = useCallback((e) => {
    if (!touchStartRef.current) return;
    const touch = e.changedTouches[0];
    const deltaX = touch.clientX - touchStartRef.current.x;
    const deltaY = Math.abs(touch.clientY - touchStartRef.current.y);
    if (deltaX > 60 && deltaX > deltaY * 1.5) {
      onBack();
    }
    touchStartRef.current = null;
  }, [onBack]);

  return { handleTouchStart, handleTouchEnd };
}
